import { render } from "./FramesGrid.vue?vue&type=template&id=e829ec42&scoped=true"
import script from "./FramesGrid.vue?vue&type=script&lang=js"
export * from "./FramesGrid.vue?vue&type=script&lang=js"

import "./FramesGrid.vue?vue&type=style&index=0&id=e829ec42&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e829ec42"]])

export default __exports__